import { render, staticRenderFns } from "./brave-link.vue?vue&type=template&id=4a9c1574"
import script from "./brave-link.vue?vue&type=script&lang=js"
export * from "./brave-link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports